import { defineStore } from 'pinia'

const NAVEGACAO_PADRAO = Object.freeze({
  titulo: '',
  tituloNovo: 'Novo(a)',
  breadcrumb: [],
})

function recuperarNavegacaoPadrao() {
  return {
    ...NAVEGACAO_PADRAO,
    breadcrumb: [...NAVEGACAO_PADRAO.breadcrumb],
  }
}

export const useAppStore = defineStore('app', {
  state: () => ({
    usuario: {
      ultimoLogin: '',
      perfil: '',
      email: '',
      nome: '',
      autenticado: false,
    },
    navegacao: recuperarNavegacaoPadrao(),
    carregando: false,
    versaoBackend: '',
  }),
  getters: {
    usuarioPerfil: (state) => state.usuario.perfil,
    usuarioEmail: (state) => state.usuario.email,
    autenticado: (state) => state.usuario.autenticado,
    titulo: (state) => state.navegacao.titulo,
    tituloNovo: (state) => state.navegacao.tituloNovo,
    breadcrumb: (state) => state.navegacao.breadcrumb,
  },
  actions: {
    setNavegacao(menu = {}) {
      const {
        descricao,
        titulo,
        descricaoNovo,
        tituloNovo,
        breadcrumb = NAVEGACAO_PADRAO.breadcrumb,
      } = menu

      this.navegacao.titulo = descricao ?? titulo ?? NAVEGACAO_PADRAO.titulo
      this.navegacao.tituloNovo =
        descricaoNovo ?? tituloNovo ?? NAVEGACAO_PADRAO.tituloNovo
      this.navegacao.breadcrumb = Array.isArray(breadcrumb) ? breadcrumb : []
    },
    resetNavegacao() {
      this.navegacao = recuperarNavegacaoPadrao()
    },
    setTitulo(titulo) {
      this.navegacao.titulo = titulo
    },
    setTituloNovo(tituloNovo) {
      this.navegacao.tituloNovo = tituloNovo
    },
    setAutenticado(autenticado) {
      this.usuario.autenticado = autenticado
    },
    setVersaoBackend(versaoBackend) {
      this.versaoBackend = versaoBackend
    },
    setUsuario(usuario = {}) {
      const { nome = '', perfil = '', email = '', ultimoLogin = '' } = usuario
      this.usuario.nome = nome
      this.usuario.perfil = perfil
      this.usuario.email = email
      this.usuario.ultimoLogin = ultimoLogin
    },
    setCarregando() {
      this.carregando = !this.carregando
    },
    setBreadcrumb(breadcrumb) {
      this.navegacao.breadcrumb = breadcrumb
    },
    pushBreadcrumb(menu) {
      this.navegacao.breadcrumb.push(menu)
    },
    popBreadcrumb() {
      this.navegacao.breadcrumb.pop()
    },
  },
})
